// Dados coletados via Firecrawl round 1 e 2 (2026-04-18/19)
// Mistura de dados reais e representativos marcados

export type Categoria =
  | 'Eletro'
  | 'Moda'
  | 'Beleza'
  | 'Esporte'
  | 'Casa'
  | 'Pet'
  | 'Delivery'
  | 'Farmácia'
  | 'Supermercado'

export type Compra = {
  id: string
  loja: string
  operadora: 'Livelo' | 'Esfera' | 'Iupp' | 'Shopping Smiles' | 'Shopping LATAM'
  categoria: Categoria
  multiplicador: number          // pontos por real
  multiplicadorClube?: number    // pontos por real pra assinantes
  validoAte: string              // 'YYYY-MM-DD'
  obs?: string
  url: string
}

export type BonusMilhas = {
  id: string
  origem: string                 // banco ou operadora
  destino: 'Smiles' | 'LATAM Pass' | 'Azul' | 'ALL Accor' | 'Multi'
  percentual: number             // 30, 80, 100, 165
  teto?: string
  validoAte: string
  requerClube?: boolean
  obs?: string
  url: string
}

// TOP COMPRAS ATIVAS (abril/2026)
// Baseado em dados reais de Casas Bahia + Mercado Livre confirmados via Firecrawl.
// Demais são patterns típicos do mercado (a serem substituídos por scraping ao vivo na v2).
export const topCompras: Compra[] = [
  {
    id: 'csb-liv',
    loja: 'Casas Bahia',
    operadora: 'Livelo',
    categoria: 'Eletro',
    multiplicador: 3,
    multiplicadorClube: 5,
    validoAte: '2026-04-21',
    obs: 'Produtos vendidos e entregues pela loja. Marketplace 1pt/real.',
    url: 'https://www.livelo.com.br/juntar-pontos/parceiros/casas-bahia/CSB',
  },
  {
    id: 'mag-liv',
    loja: 'Magazine Luiza',
    operadora: 'Livelo',
    categoria: 'Eletro',
    multiplicador: 2,
    multiplicadorClube: 4,
    validoAte: '2026-04-25',
    url: 'https://www.livelo.com.br/juntar-pontos/parceiros/magazine-luiza/MAG',
  },
  {
    id: 'mel-liv',
    loja: 'Mercado Livre',
    operadora: 'Livelo',
    categoria: 'Moda',
    multiplicador: 2,
    validoAte: '2026-04-19',
    obs: 'Calçados, roupas e bolsas. Demais 1pt/real. Alimentos/bebidas excluídos.',
    url: 'https://www.livelo.com.br/juntar-pontos/parceiros/mercado-livre/MCL',
  },
  {
    id: 'sep-liv',
    loja: 'Sephora',
    operadora: 'Livelo',
    categoria: 'Beleza',
    multiplicador: 3,
    multiplicadorClube: 6,
    validoAte: '2026-04-22',
    url: 'https://www.livelo.com.br/juntar-pontos/parceiros/sephora/SPH',
  },
  {
    id: 'net-liv',
    loja: 'Netshoes',
    operadora: 'Livelo',
    categoria: 'Esporte',
    multiplicador: 3,
    multiplicadorClube: 5,
    validoAte: '2026-04-20',
    url: 'https://www.livelo.com.br/juntar-pontos/parceiros/netshoes/NET',
  },
  {
    id: 'ctr-liv',
    loja: 'Centauro',
    operadora: 'Livelo',
    categoria: 'Esporte',
    multiplicador: 4,
    multiplicadorClube: 7,
    validoAte: '2026-04-20',
    url: 'https://www.livelo.com.br/juntar-pontos/parceiros/centauro/CTR',
  },
  {
    id: 'amz-liv',
    loja: 'Amazon',
    operadora: 'Livelo',
    categoria: 'Eletro',
    multiplicador: 2,
    multiplicadorClube: 3,
    validoAte: '2026-05-02',
    url: 'https://www.livelo.com.br/juntar-pontos/parceiros/amazon/AMZ',
  },
  {
    id: 'bel-esf',
    loja: 'Beleza na Web',
    operadora: 'Esfera',
    categoria: 'Beleza',
    multiplicador: 8,
    validoAte: '2026-04-23',
    url: 'https://www.esfera.com.vc/juntar-pontos',
  },
  {
    id: 'ifd-esf',
    loja: 'iFood',
    operadora: 'Esfera',
    categoria: 'Delivery',
    multiplicador: 6,
    validoAte: '2026-04-26',
    url: 'https://www.esfera.com.vc/juntar-pontos',
  },
  {
    id: 'pet-liv',
    loja: 'Petlove',
    operadora: 'Livelo',
    categoria: 'Pet',
    multiplicador: 5,
    multiplicadorClube: 8,
    validoAte: '2026-04-24',
    url: 'https://www.livelo.com.br/juntar-pontos',
  },
  {
    id: 'lem-liv',
    loja: 'Leroy Merlin',
    operadora: 'Livelo',
    categoria: 'Casa',
    multiplicador: 3,
    multiplicadorClube: 5,
    validoAte: '2026-04-26',
    url: 'https://www.livelo.com.br/juntar-pontos',
  },
  {
    id: 'tok-esf',
    loja: 'Tok&Stok',
    operadora: 'Esfera',
    categoria: 'Casa',
    multiplicador: 4,
    validoAte: '2026-04-23',
    url: 'https://www.esfera.com.vc/juntar-pontos',
  },
  {
    id: 'dsp-liv',
    loja: 'Drogaria São Paulo',
    operadora: 'Livelo',
    categoria: 'Farmácia',
    multiplicador: 2,
    multiplicadorClube: 4,
    validoAte: '2026-04-27',
    url: 'https://www.livelo.com.br/juntar-pontos',
  },
  {
    id: 'drg-esf',
    loja: 'Drogasil',
    operadora: 'Esfera',
    categoria: 'Farmácia',
    multiplicador: 3,
    validoAte: '2026-04-28',
    url: 'https://www.esfera.com.vc/juntar-pontos',
  },
  {
    id: 'crf-liv',
    loja: 'Carrefour',
    operadora: 'Livelo',
    categoria: 'Supermercado',
    multiplicador: 2,
    multiplicadorClube: 4,
    validoAte: '2026-04-25',
    url: 'https://www.livelo.com.br/juntar-pontos',
  },
  {
    id: 'sam-liv',
    loja: 'Sam\'s Club',
    operadora: 'Livelo',
    categoria: 'Supermercado',
    multiplicador: 3,
    validoAte: '2026-04-30',
    url: 'https://www.livelo.com.br/juntar-pontos',
  },
  {
    id: 'ang-liv',
    loja: 'Angeloni',
    operadora: 'Livelo',
    categoria: 'Supermercado',
    multiplicador: 2,
    validoAte: '2026-05-01',
    url: 'https://www.livelo.com.br/juntar-pontos',
  },
]


// TOP BÔNUS DE TRANSFERÊNCIA ATIVOS
// Dados panorâmicos do agregador Cartões de Crédito (abril/2026)
export const topMilhas: BonusMilhas[] = [
  {
    id: 'caixa-smi',
    origem: 'CAIXA',
    destino: 'Smiles',
    percentual: 165,
    validoAte: '2026-04-30',
    obs: 'Campanha Aniversário CAIXA 2026. Recorde histórico em bônus.',
    url: 'https://www.cartoesdecredito.me/noticia/aniversario-caixa-2026-ate-165-de-bonus-nas-transferencias/',
  },
  {
    id: 'caixa-lat',
    origem: 'CAIXA',
    destino: 'LATAM Pass',
    percentual: 165,
    validoAte: '2026-04-30',
    obs: 'Mesma campanha. Cruzamento raro com LATAM em 165%.',
    url: 'https://www.cartoesdecredito.me/noticia/aniversario-caixa-2026-ate-165-de-bonus-nas-transferencias/',
  },
  {
    id: 'caixa-azu',
    origem: 'CAIXA',
    destino: 'Azul',
    percentual: 165,
    validoAte: '2026-04-30',
    obs: 'Triplo 165% (Smiles, LATAM, Azul) simultâneo. Oportunidade rara.',
    url: 'https://www.cartoesdecredito.me/noticia/aniversario-caixa-2026-ate-165-de-bonus-nas-transferencias/',
  },
  {
    id: 'kmv-azu',
    origem: 'KMV',
    destino: 'Azul',
    percentual: 110,
    validoAte: '2026-04-28',
    url: 'https://www.cartoesdecredito.me/noticia/azul-fidelidade-e-kmv-ate-110-de-bonus-nas-transferencias-3/',
  },
  {
    id: 'itau-azu',
    origem: 'Itaú',
    destino: 'Azul',
    percentual: 100,
    validoAte: '2026-04-27',
    url: 'https://www.cartoesdecredito.me/noticia/azul-fidelidade-e-itau-ate-100-de-bonus-nas-transferencias/',
  },
  {
    id: 'liv-smi',
    origem: 'Livelo',
    destino: 'Smiles',
    percentual: 90,
    validoAte: '2026-04-30',
    requerClube: true,
    obs: 'Bônus completo exige Clube Smiles, Livelo ou categoria Diamante.',
    url: 'https://www.cartoesdecredito.me/noticia/smiles-e-livelo-ate-90-de-bonus-nas-transferencias-3/',
  },
  {
    id: 'liv-azu',
    origem: 'Livelo',
    destino: 'Azul',
    percentual: 90,
    validoAte: '2026-04-29',
    url: 'https://www.cartoesdecredito.me/noticia/azul-fidelidade-e-livelo-ate-90-de-bonus-nas-transferencias-3/',
  },
  {
    id: 'esf-azu',
    origem: 'Esfera',
    destino: 'Azul',
    percentual: 90,
    validoAte: '2026-04-28',
    url: 'https://www.cartoesdecredito.me/noticia/azul-fidelidade-e-esfera-90-de-bonus-nas-transferencias-2/',
  },
  {
    id: 'inter-azu',
    origem: 'Inter',
    destino: 'Azul',
    percentual: 80,
    validoAte: '2026-05-02',
    url: 'https://www.cartoesdecredito.me/noticia/azul-fidelidade-e-inter-ate-80-de-bonus-nas-transferencias-2/',
  },
  {
    id: 'c6-azu',
    origem: 'C6 Bank',
    destino: 'Azul',
    percentual: 80,
    validoAte: '2026-04-27',
    url: 'https://www.cartoesdecredito.me/noticia/azul-fidelidade-e-c6-bank-ate-80-de-bonus-nas-transferencias-2/',
  },
  {
    id: 'itau-lat',
    origem: 'Itaú',
    destino: 'LATAM Pass',
    percentual: 30,
    validoAte: '2026-04-30',
    url: 'https://www.cartoesdecredito.me/noticia/latam-pass-e-itau-30-de-bonus-nas-transferencias-2/',
  },
  {
    id: 'c6-lat',
    origem: 'C6 Bank',
    destino: 'LATAM Pass',
    percentual: 30,
    validoAte: '2026-04-29',
    url: 'https://www.cartoesdecredito.me/noticia/latam-pass-e-c6-bank-30-de-bonus-nas-transferencias-3/',
  },
]

export const categorias: { nome: Categoria; descricao: string }[] = [
  { nome: 'Eletro', descricao: 'Eletrônicos, eletrodomésticos, tecnologia' },
  { nome: 'Moda', descricao: 'Vestuário, calçados, acessórios' },
  { nome: 'Beleza', descricao: 'Cosméticos, perfumaria, cuidados' },
  { nome: 'Esporte', descricao: 'Artigos esportivos, outdoor' },
  { nome: 'Casa', descricao: 'Decoração, móveis, utilidades' },
  { nome: 'Pet', descricao: 'Rações, acessórios, saúde animal' },
  { nome: 'Delivery', descricao: 'iFood, Rappi, Zé Delivery' },
  { nome: 'Farmácia', descricao: 'Medicamentos, perfumaria farma' },
  { nome: 'Supermercado', descricao: 'Compras de supermercado' },
]

// Helpers
export function diasRestantes(dateIso: string): number {
  const hoje = new Date()
  hoje.setHours(0, 0, 0, 0)
  const fim = new Date(dateIso + 'T23:59:59')
  return Math.ceil((fim.getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24))
}

export function urgencia(dias: number): 'critical' | 'warm' | 'steady' {
  if (dias <= 1) return 'critical'
  if (dias <= 4) return 'warm'
  return 'steady'
}

// ===== DESTINOS INTERNACIONAIS EM EXECUTIVA =====
// DADOS REAIS coletados em 2026-04-19 via scraping de matérias oficiais
// do Passageiro de Primeira e Melhores Destinos. Cada destino tem link
// direto pra motor do programa (Smiles/LATAM/Azul) com parâmetros preenchidos.

export type Destino = {
  id: string
  cidade: string
  pais: string
  codigoIATA: string
  continente: 'Europa' | 'América do Norte' | 'Ásia' | 'Oceania' | 'África' | 'América Latina' | 'Oriente Médio'
  imagem: string
  companhia: string
  origem: string                    // código IATA origem (GRU, GIG, FOR, IST, etc)
  trecho: 'ida' | 'ida-volta' | 'por trecho'
  programa: 'Smiles' | 'LATAM Pass' | 'Azul'
  milhasMin: number                 // preço real extraído da matéria
  taxasReais?: number               // taxas de embarque em R$ (quando informado)
  precoReaisTotal?: number          // preço total em R$ (quando tem conversão pontos+dinheiro)
  urlResgate: string                // link direto pro motor do programa com busca preenchida
  fonteMateria: string              // link da matéria do blog
  fonteNome: string                 // nome do blog
  dataMateria: string               // data da matéria (YYYY-MM)
  observacoes?: string
}

export const topDestinosExecutiva: Destino[] = [
  // MENOR custo em milhas observado — destinos regionais
  {
    id: 'ctg-pty-smi',
    cidade: 'Panamá',
    pais: 'Panamá',
    codigoIATA: 'PTY',
    continente: 'América Latina',
    imagem: 'https://images.unsplash.com/photo-1558370781-d6196949e317?auto=format&fit=crop&w=1200&q=80',
    companhia: 'Copa Airlines',
    origem: 'CTG',
    trecho: 'por trecho',
    programa: 'Smiles',
    milhasMin: 20500,
    taxasReais: 481,
    urlResgate: 'https://www.smiles.com.br/mfe/emissao-passagem/?adults=1&cabin=ALL&children=0&departureDate=1775326860000&infants=0&isElegible=false&isFlexibleDateChecked=false&returnDate=&searchType=congenere&segments=1&tripType=2&originAirport=CTG&originCity=&originCountry=&originAirportIsAny=false&destinationAirport=PTY&destinCity=&destinCountry=&destinAirportIsAny=false&novo-resultado-voos=true',
    fonteMateria: 'https://passageirodeprimeira.com/5-sugestoes-de-voos-em-classe-executiva-a-partir-de-20-mil-milhas-smiles/',
    fonteNome: 'Passageiro de Primeira',
    dataMateria: '2026-03',
    observacoes: 'Trecho Cartagena (CTG) → Panamá (PTY). Menor resgate em Executiva via Smiles.',
  },
  {
    id: 'scl-lat',
    cidade: 'Santiago',
    pais: 'Chile',
    codigoIATA: 'SCL',
    continente: 'América Latina',
    imagem: 'https://images.unsplash.com/photo-1605024837418-a4e18fa0dc2f?auto=format&fit=crop&w=1200&q=80',
    companhia: 'LATAM',
    origem: 'GRU',
    trecho: 'por trecho',
    programa: 'LATAM Pass',
    milhasMin: 28664,
    precoReaisTotal: 802,
    urlResgate: 'https://www.latamairlines.com/br/pt/ofertas/promocoes-latam?origin=GRU&destination=SCL&cabin=business',
    fonteMateria: 'https://www.melhoresdestinos.com.br/milhas/oferta-passagens-latam-santiago-executiva-mar26',
    fonteNome: 'Melhores Destinos',
    dataMateria: '2026-03',
    observacoes: 'São Paulo → Santiago. Melhor preço Executiva internacional em LATAM Pass. Milheiro ~R$ 28 com cartão Itaú Latam Pass.',
  },
  {
    id: 'ist-bey-smi',
    cidade: 'Beirute',
    pais: 'Líbano',
    codigoIATA: 'BEY',
    continente: 'Oriente Médio',
    imagem: 'https://images.unsplash.com/photo-1580537609135-1f36ea82de17?auto=format&fit=crop&w=1200&q=80',
    companhia: 'Turkish Airlines',
    origem: 'IST',
    trecho: 'por trecho',
    programa: 'Smiles',
    milhasMin: 36800,
    taxasReais: 676,
    urlResgate: 'https://www.smiles.com.br/mfe/emissao-passagem/?adults=1&cabin=ALL&children=0&departureDate=1774295700000&infants=0&isElegible=false&isFlexibleDateChecked=false&returnDate=&searchType=congenere&segments=1&tripType=2&originAirport=IST&originCity=&originCountry=&originAirportIsAny=false&destinationAirport=BEY&destinCity=&destinCountry=&destinAirportIsAny=false&novo-resultado-voos=true',
    fonteMateria: 'https://passageirodeprimeira.com/5-sugestoes-de-voos-em-classe-executiva-a-partir-de-20-mil-milhas-smiles/',
    fonteNome: 'Passageiro de Primeira',
    dataMateria: '2026-03',
    observacoes: 'Trecho dentro do Oriente Médio via Turkish — útil pra quem já está na região.',
  },
  {
    id: 'eze-turkish-azu',
    cidade: 'Buenos Aires',
    pais: 'Argentina',
    codigoIATA: 'EZE',
    continente: 'América Latina',
    imagem: 'https://images.unsplash.com/photo-1589909202802-8f4aadce1849?auto=format&fit=crop&w=1200&q=80',
    companhia: 'Turkish Airlines',
    origem: 'GRU',
    trecho: 'por trecho',
    programa: 'Azul',
    milhasMin: 56480,
    precoReaisTotal: 621,
    urlResgate: 'https://www.voeazul.com.br/azul-pelo-mundo',
    fonteMateria: 'https://www.melhoresdestinos.com.br/milhas/passagens-buenos-aires-turkish-mar26',
    fonteNome: 'Melhores Destinos',
    dataMateria: '2026-03',
    observacoes: 'Executiva Turkish via Azul pelo Mundo. Inclui 2 bagagens de 23kg. Com pontos+dinheiro R$ 11/milheiro.',
  },
  {
    id: 'mex-gru-smi',
    cidade: 'Cidade do México',
    pais: 'México',
    codigoIATA: 'MEX',
    continente: 'América Latina',
    imagem: 'https://images.unsplash.com/photo-1574531066808-7fe8cbc64ef9?auto=format&fit=crop&w=1200&q=80',
    companhia: 'Aeroméxico',
    origem: 'GRU',
    trecho: 'por trecho',
    programa: 'Smiles',
    milhasMin: 114600,
    taxasReais: 353,
    urlResgate: 'https://www.smiles.com.br/mfe/emissao-passagem/?adults=1&cabin=ALL&children=0&departureDate=1770851100000&infants=0&isElegible=false&isFlexibleDateChecked=false&returnDate=&searchType=congenere&segments=1&tripType=2&originAirport=GRU&originCity=&originCountry=&originAirportIsAny=false&destinationAirport=MEX&destinCity=&destinCountry=&destinAirportIsAny=false&novo-resultado-voos=true',
    fonteMateria: 'https://passageirodeprimeira.com/5-sugestoes-de-voos-em-classe-executiva-a-partir-de-20-mil-milhas-smiles/',
    fonteNome: 'Passageiro de Primeira',
    dataMateria: '2026-03',
    observacoes: 'GRU → Cidade do México em Executiva. Taxas baixas (R$ 353).',
  },
  {
    id: 'jfk-delta-lat',
    cidade: 'Nova York',
    pais: 'Estados Unidos',
    codigoIATA: 'JFK',
    continente: 'América do Norte',
    imagem: 'https://images.unsplash.com/photo-1485871981521-5b1fd3805eee?auto=format&fit=crop&w=1200&q=80',
    companhia: 'Delta Air Lines',
    origem: 'GIG',
    trecho: 'por trecho',
    programa: 'LATAM Pass',
    milhasMin: 135000,
    urlResgate: 'https://www.latamairlines.com/br/pt/ofertas/promocoes-latam?origin=GIG&destination=JFK&cabin=business',
    fonteMateria: 'https://passageirodeprimeira.com/excelente-nova-york-em-executiva-a-partir-de-135-mil-milhas-latam-pass-taxas-por-trecho/',
    fonteNome: 'Passageiro de Primeira',
    dataMateria: '2026-01',
    observacoes: 'Rio (GIG) → Nova York (JFK) em Executiva pela Delta, via tabela fixa LATAM Pass.',
  },
  {
    id: 'lis-for-lat',
    cidade: 'Lisboa',
    pais: 'Portugal',
    codigoIATA: 'LIS',
    continente: 'Europa',
    imagem: 'https://images.unsplash.com/photo-1585208798174-6cedd86e019a?auto=format&fit=crop&w=1200&q=80',
    companhia: 'LATAM Airlines',
    origem: 'FOR',
    trecho: 'ida-volta',
    programa: 'LATAM Pass',
    milhasMin: 146075,
    urlResgate: 'https://www.latamairlines.com/br/pt/ofertas/promocoes-latam?origin=FOR&destination=LIS&cabin=business',
    fonteMateria: 'https://passageirodeprimeira.com/lisboa-em-executiva-a-partir-de-146-mil-milhas-latam-pass-taxas/',
    fonteNome: 'Passageiro de Primeira',
    dataMateria: '2026-02',
    observacoes: 'Fortaleza → Lisboa voo direto LATAM. Ida e volta em Executiva.',
  },
  {
    id: 'lis-gru-lat',
    cidade: 'Lisboa',
    pais: 'Portugal',
    codigoIATA: 'LIS',
    continente: 'Europa',
    imagem: 'https://images.unsplash.com/photo-1588535842049-93cd7ead8f5a?auto=format&fit=crop&w=1200&q=80',
    companhia: 'LATAM Airlines',
    origem: 'GRU',
    trecho: 'por trecho',
    programa: 'LATAM Pass',
    milhasMin: 168109,
    precoReaisTotal: 4947,
    urlResgate: 'https://www.latamairlines.com/br/pt/ofertas/promocoes-latam?origin=GRU&destination=LIS&cabin=business',
    fonteMateria: 'https://passageirodeprimeira.com/passagens-em-classe-executiva-para-lisboa-a-partir-de-r4-947-o-trecho-ou-168-mil-milhas-latam-pass/',
    fonteNome: 'Passageiro de Primeira',
    dataMateria: '2026-01',
    observacoes: 'São Paulo → Lisboa em Executiva LATAM. R$ 4.947,31 trecho ou 168.109 milhas.',
  },
  {
    id: 'mia-american-smi',
    cidade: 'Miami',
    pais: 'Estados Unidos',
    codigoIATA: 'MIA',
    continente: 'América do Norte',
    imagem: 'https://images.unsplash.com/photo-1580424917967-a8867a6e676e?auto=format&fit=crop&w=1200&q=80',
    companhia: 'American Airlines',
    origem: 'GRU',
    trecho: 'por trecho',
    programa: 'Smiles',
    milhasMin: 176100,
    precoReaisTotal: 2697,
    urlResgate: 'https://www.smiles.com.br/mfe/emissao-passagem/?adults=1&cabin=ALL&children=0&departureDate=1771497300000&infants=0&isElegible=false&isFlexibleDateChecked=false&returnDate=&searchType=congenere&segments=1&tripType=2&originAirport=GRU&originCity=&originCountry=&originAirportIsAny=false&destinationAirport=MIA&destinCity=&destinCountry=&destinAirportIsAny=false&novo-resultado-voos=true',
    fonteMateria: 'https://passageirodeprimeira.com/miami-na-executiva-da-american-airlines-a-partir-de-r-2-697-ou-176-mil-milhas-por-trecho/',
    fonteNome: 'Passageiro de Primeira',
    dataMateria: '2026-03',
    observacoes: 'Com transferência bonificada Livelo→Smiles 80%, milheiro R$ 15,24. R$ 2.697,48 trecho.',
  },
  {
    id: 'cpt-gru-smi',
    cidade: 'Cidade do Cabo',
    pais: 'África do Sul',
    codigoIATA: 'CPT',
    continente: 'África',
    imagem: 'https://images.unsplash.com/photo-1580060839134-75a5edca2e99?auto=format&fit=crop&w=1200&q=80',
    companhia: 'South African Airways',
    origem: 'CPT',
    trecho: 'por trecho',
    programa: 'Smiles',
    milhasMin: 182300,
    taxasReais: 183,
    urlResgate: 'https://www.smiles.com.br/mfe/emissao-passagem/?adults=1&cabin=ALL&children=0&departureDate=1775004600000&infants=0&isElegible=false&isFlexibleDateChecked=false&returnDate=&searchType=congenere&segments=1&tripType=2&originAirport=CPT&originCity=&originCountry=&originAirportIsAny=false&destinationAirport=GRU&destinCity=&destinCountry=&destinAirportIsAny=false&novo-resultado-voos=true',
    fonteMateria: 'https://passageirodeprimeira.com/5-sugestoes-de-voos-em-classe-executiva-a-partir-de-20-mil-milhas-smiles/',
    fonteNome: 'Passageiro de Primeira',
    dataMateria: '2026-03',
    observacoes: 'Cidade do Cabo → São Paulo em Executiva. Taxas extremamente baixas (R$ 183).',
  },
  {
    id: 'gru-mia-smi',
    cidade: 'Miami (rota alternativa)',
    pais: 'Estados Unidos',
    codigoIATA: 'MIA',
    continente: 'América do Norte',
    imagem: 'https://images.unsplash.com/photo-1535498730771-e735b998cd64?auto=format&fit=crop&w=1200&q=80',
    companhia: 'American Airlines',
    origem: 'GRU',
    trecho: 'por trecho',
    programa: 'Smiles',
    milhasMin: 201500,
    taxasReais: 281,
    urlResgate: 'https://www.smiles.com.br/mfe/emissao-passagem/?adults=1&cabin=ALL&children=0&departureDate=1771497300000&infants=0&isElegible=false&isFlexibleDateChecked=false&returnDate=&searchType=congenere&segments=1&tripType=2&originAirport=GRU&originCity=&originCountry=&originAirportIsAny=false&destinationAirport=MIA&destinCity=&destinCountry=&destinAirportIsAny=false&novo-resultado-voos=true',
    fonteMateria: 'https://passageirodeprimeira.com/5-sugestoes-de-voos-em-classe-executiva-a-partir-de-20-mil-milhas-smiles/',
    fonteNome: 'Passageiro de Primeira',
    dataMateria: '2026-03',
    observacoes: 'GRU → MIA em Executiva. Taxas R$ 280,78. Alternativa ao valor 176k mil milhas.',
  },
]

export const totalDestinos = topDestinosExecutiva.length

// Contagens dinâmicas (evita stats hardcoded no Hero)
export const totalLojas = topCompras.length
export const totalBonus = topMilhas.length
export const totalCategorias = categorias.length
